<div
	class="page-header page-header-dark bg-gradient-primary-to-secondary"
	[ngClass]="{
		'pb-10': !simplified,
		'page-header-dark bg-gradient-primary-to-secondary': !light,
		'page-header-light bg-white shadow': light
	}">
	<div class="container-xl px-4">
		<div class="page-header-content pt-4">
			@if (loading) {
				<div class="row gx-4 align-items-center">
					<div class="col placeholder-glow">
						<span class="placeholder w-75"></span>
						<span class="placeholder w-50"></span>
					</div>
				</div>
			} @else {
				<div class="row gx-4 align-items-center justify-content-between">
					<div class="col-md mt-4">
						<h1 class="page-header-title lh-1">
							@if (icon) {
								<div class="page-header-icon">
									@if (awesome) {
										<fa-icon [icon]="iconProp"></fa-icon>
									} @else {
										<i-feather [name]="icon"></i-feather>
									}
								</div>
							}
							<span>{{ title }}</span>
						</h1>
						<div class="page-header-subtitle lh-1">{{ description }}</div>
						@if (breadcrumbs) {
							<sb-breadcrumbs></sb-breadcrumbs>
						}
					</div>
					@if (dateSelect) {
						<div class="col-12 col-xl-auto mt-4 d-flex justify-content-md-start justify-content-center">
							@if (dateRange) {
								<sbpro-date-range-quick></sbpro-date-range-quick>
							} @else {
								<div class="d-block w-100">
									<sbpro-dropdown
										dropdownStyle="text"
										background="btn-white"
										[classes]="['pe-0 pe-sm-3', 'pe-md-0', 'font-weight-600', 'line-height-normal']">
										<div class="dropdown-trigger">
											<div class="text-wrap d-flex align-items-center">
												<i-feather class="text-primary me-2" name="calendar"></i-feather>
												{{ dateSelectValue?.label ?? 'Selecione o exercício' }}
											</div>
										</div>
										<div class="dropdown-items d-inline-flex">
											<div class="items p-0 m-0">
												@for (item of dateSelectItems; track item; let last = $last) {
													<a
														class="dropdown-item p-3"
														(click)="dateSelected(item)"
														[ngClass]="{ active: item?.value === dateSelectValue?.value, 'border-bottom': !last }">
														{{ item.label }}
													</a>
												}
											</div>
										</div>
									</sbpro-dropdown>
								</div>
							}
						</div>
					}
				</div>
				@if (showSearch) {
					<div class="page-header-search mt-4">
						<div class="input-group input-group-joined">
							<input class="form-control" type="text" placeholder="Search..." aria-label="Search" autofocus />
							<div class="input-group-text">
								<i-feather name="search"></i-feather>
							</div>
						</div>
					</div>
				}
			}
		</div>
	</div>
</div>
